"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _AppIcon = _interopRequireDefault(require("../ImagesAndIcons/AppIcon"));

var _InternalLink = _interopRequireDefault(require("../Navigation/InternalLink"));

var _PageDetailsTitle = _interopRequireDefault(require("../TitlesAndTexts/PageDetailsTitle"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const PageHeaderWrapper = _styledComponents.default.header.withConfig({
  displayName: "PageHeader__PageHeaderWrapper",
  componentId: "design-system__dyohhg-0"
})(["& > div{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;& > .logo{margin-right:0.5rem;}& > div.title > h1{line-height:", ";}& > div.title > small{display:block;font-size:", ";color:", ";line-height:", ";}& > div.title div{margin-top:0.5rem;}}"], _BaseTheme.default.type.lineHeight.none, _BaseTheme.default.type.size.normal, _BaseTheme.default.colors.textgray, _BaseTheme.default.type.lineHeight.none);

const PageHeader = _ref => {
  let {
    title,
    subtitle,
    appIcon,
    previousPath,
    goBackTo,
    onClick
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "subtitle", "appIcon", "previousPath", "goBackTo", "onClick"]);

  return /*#__PURE__*/_react.default.createElement(PageHeaderWrapper, props, goBackTo && (previousPath ? /*#__PURE__*/_react.default.createElement(_InternalLink.default, {
    type: "small",
    to: previousPath
  }, "Go back to ".concat(goBackTo)) : /*#__PURE__*/_react.default.createElement(_InternalLink.default, {
    type: "small",
    onClick: onClick
  }, "Go back to ".concat(goBackTo))), /*#__PURE__*/_react.default.createElement("div", null, appIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/_react.default.createElement(_AppIcon.default, {
    type: appIcon,
    size: "56"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement(_PageDetailsTitle.default, null, title), subtitle && /*#__PURE__*/_react.default.createElement("small", null, subtitle))));
};

PageHeader.propTypes = {
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  appIcon: _propTypes.default.string,
  previousPath: _propTypes.default.string,
  goBackTo: _propTypes.default.string,
  onClick: _propTypes.default.func
};
PageHeader.defaultProps = {
  appIcon: null,
  subtitle: undefined,
  goBackTo: undefined,
  previousPath: undefined,
  onClick: undefined
};
var _default = PageHeader;
exports.default = _default;